<template>
    <div id="event-modal">
        <div v-if="getGoogleMeetLink()" class="google-meet-btn">
            <a :href="getGoogleMeetLink()" target="_blank">
                <supsis-button primary>
                    <span class="material-icons">videocam</span>
                    Google Meet'i aç
                </supsis-button>
            </a>
            <div class="meet-link-container">
                <span class="meet-link">{{ getGoogleMeetLink() }}</span>
                <supsis-button xsmall @click="copyMeetLink" icon="content_copy" />
            </div>
        </div>
        <a-divider />

        <input :placeholder="$t('calendar.title')" class="event-input" v-model="eventModalData.summary" />

        <div class="info">
            <span class="material-icons single">access_time</span>
            <div class="custom-datetime-container">
                <div class="datetime-row">
                    <label class="datetime-label">Başlangıç:</label>
                    <input
                        type="date"
                        class="custom-date-input"
                        v-model="startDateString"
                        @change="onStartDateStringChange"
                    />
                    <input
                        v-if="!eventModalData.isAllDay"
                        type="time"
                        class="custom-time-input"
                        v-model="startTimeString"
                        @change="onStartTimeStringChange"
                    />
                </div>
                <div class="datetime-row" v-if="eventModalData.isAllDay">
                    <label class="datetime-label">Bitiş:</label>
                    <input
                        type="date"
                        class="custom-date-input"
                        v-model="endDateString"
                        @change="onEndDateStringChange"
                    />
                </div>
                <div class="datetime-row" v-else>
                    <label class="datetime-label">Bitiş:</label>
                    <input
                        type="date"
                        class="custom-date-input"
                        v-model="endDateString"
                        @change="onEndDateStringChange"
                    />
                    <input
                        type="time"
                        class="custom-time-input"
                        v-model="endTimeString"
                        @change="onEndTimeStringChange"
                    />
                </div>
            </div>
        </div>
        <div class="info">
            <a-checkbox v-model="eventModalData.isAllDay" style="width: 100px">{{ $t("calendar.allDay") }}</a-checkbox>
            <a-select v-model="timezone" show-search style="width: 100%">
                <a-select-option v-for="(tz, index) of timezones" :key="index" :value="tz">
                    {{ tz }}
                </a-select-option>
            </a-select>
        </div>
        <div>
            <a-select
                v-model="eventModalData.repeat"
                show-search
                style="width: 100%; margin-top: 15px"
                @change="changeRepeat"
            >
                <a-select-option v-for="(repeatTime, index) of repeatTimes" :key="index" :value="repeatTime.value">
                    {{ repeatTime.label }}
                </a-select-option>
            </a-select>
        </div>
        <div class="info">
            <div style="display: flex; align-items: flex-end">
                <span class="material-icons">people</span>
                <span style="margin-left: 5px">{{ $t("calendar.agents") }}</span>
            </div>
            <a-select v-model="eventModalData.refUsers" show-search style="width: 100%; margin-left: 10px" mode="tags">
                <a-select-option v-for="(user, index) of usersClone" :key="index" :value="user._id">
                    {{ user.name }}
                </a-select-option>
            </a-select>
        </div>
        <div class="info">
            <div style="display: flex; align-items: flex-end">
                <span class="material-icons">person</span>
                <span style="margin-left: 5px">{{ $t("calendar.visitor") }}</span>
            </div>
            <a-select
                v-model="eventModalData.refVisitor"
                show-search
                style="width: 100%; margin-left: 10px"
                @focus="getVisitorsFunction()"
                @search="getVisitorsFunction"
                @click="getVisitorsFunction()"
                placeholder="Visitor seçiniz..."
                :filterOption="false"
            >
                <a-select-option v-for="(visitor, index) of visitors" :key="index" :value="visitor._id">
                    {{ !!visitor.fullname ? visitor.fullname : maskField('email', visitor.email) || visitor._id }}
                </a-select-option>
            </a-select>
        </div>
        <div class="info">
            <input type="number" class="duration" v-model="duration" />
            <a-select v-model="unit" show-search style="width: 100%; margin-left: 10px">
                <a-select-option v-for="(remindDate, index) of remindDates" :key="index" :value="remindDate">
                    {{ remindDate }}
                </a-select-option>
            </a-select>
        </div>
        <div class="info">
            <span class="material-icons">subject</span>
            <a-input placeholder="Description" :class="$t('calendar.subject')" v-model="eventModalData.description" />
        </div>
        <div class="info">
            <span class="material-icons attach-icon">attach_file</span>
            <div style="margin-left: 10px">
                <button class="attache_file_btn" @click="selectFile">
                    <span>Attach File</span>
                </button>
                <div class="attachments" v-if="attachments.length > 0">
                    <div class="attachment" v-for="(attachment, index) of attachments" :key="index">
                        <div class="left">
                            <span class="filename">{{ attachment.file.name }}</span>
                            <span class="size">({{ attachment.newSize }} kB)</span>
                        </div>
                        <span
                            v-if="fileLoading === 100"
                            class="material-icons"
                            style="font-size: 16px; cursor: pointer"
                            @click="deleteAttachment(index)"
                            >delete</span
                        >
                        <span v-else>{{ fileLoading }}%</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="info">
            <span class="material-icons lock-icon">lock</span>
            <a-select v-model="eventModalData.visibility" style="width: 100%">
                <a-select-option v-for="(visibility, index) of visibilities" :key="index" :value="visibility.value">
                    {{ visibility.label }}
                </a-select-option>
            </a-select>
        </div>
        <div class="info">
            <span class="material-icons lock-icon">calendar_today</span>
            <a-select v-model="eventModalData.calendarId" style="width: 100%">
                <a-select-option v-for="(calendar, index) of supsisCalendars" :key="index" :value="calendar.value">
                    {{ calendar.label }}
                </a-select-option>
            </a-select>
        </div>
        <div class="info">
            <a :href="getLinkGoogle()" target="_blank" class="">{{ $t("calendar.googleCalendarLink") }}</a>
        </div>
        <div class="info">
            <a :href="getLinkYahoo()" target="_blank" class="">{{ $t("calendar.yahooCalendarLink") }}</a>
        </div>
        <div class="footer-action" v-if="footerVisible && isSupsisEvent">
            <span class="btn delete" @click="deleteEvent()" v-if="Object.keys(this.eventDetail).length > 0">
                {{ $t("calendar.delete") }}
            </span>
            <span class="btn" @click="$emit('close')">{{ $t("calendar.cancel") }}</span>
            <span class="btn" @click="editOrCreateEvent()">{{ $t("calendar.save") }}</span>
        </div>
        <CustomRepeat v-if="customRepeatModal" @close="customRepeatModal = false" @save="customRecurrence = $event" />
        <a-modal
            :visible="deleteModal"
            cancelText="Vazgeç"
            :okText="$t('calendar.delete')"
            centered
            :footer="null"
            @cancel="deleteModal = false"
        >
            <div class="delete-title">{{ $t("calendar.deleteRepeatEvent") }}</div>
            <a-radio-group v-model="selectDeleteType" style="display: flex; flex-direction: column">
                <a-radio value="single" style="display: flex"> {{ $t("calendar.thisEvent") }} </a-radio>
                <a-radio value="after" style="display: flex"> {{ $t("calendar.thisAndOtherEvent") }}</a-radio>
                <a-radio value="all" style="display: flex"> {{ $t("calendar.allEvent") }}</a-radio>
            </a-radio-group>
            <div class="footer-btns">
                <span class="footer-btn" @click="deleteModal = false"> {{ $t("calendar.cancel") }}</span>
                <span class="footer-btn" @click="deleteEventSelectType()">{{ $t("calendar.ok") }}</span>
            </div>
        </a-modal>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { log2 } from "../../../../utils/log2";
import { getExtensionFromFileName, maskContactInfo, isMaskContactInfo } from "../../../../utils/utils";
import { uploadAsset } from "../../../../api/assetUpload";
import mimeTypes from "../../../../components/util/mimeTypes";
import axios from "axios";
import moment from "moment";
import _ from "lodash";
import CustomRepeat from "./CustomRepeat.vue";
import SupsisButton from "../../../Pages/Settings/components/SupsisButton.vue";

const momentTimezoneList = moment.tz.names();
moment.locale("tr");
const log = log2("EventModal");
export default {
    name: "EventModal",
    components: { CustomRepeat, SupsisButton },
    props: {
        footerVisible: {
            type: Boolean,
            default: true,
        },
        refVisitor: {
            type: String,
            default: "",
        },
        eventSummary: {
            type: String,
            default: "",
        },
        repeatTimes: {
            type: Array,
            default: () => [],
        },
        visibilities: {
            type: Array,
            default: () => [],
        },
        selectedStartDate: {
            type: Date,
            default: () => new Date(),
        },
        selectedEndDate: {
            type: Date,
            default: () => new Date(),
        },
        eventDetail: {
            type: Object,
            default: () => {},
        },
        eventFunction: {
            type: Function,
        },
        calendarList: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            timezone: "Europe/Istanbul",
            timezones: momentTimezoneList,
            eventModalData: {},
            modalBaseData: {
                summary: "",
                refUsers: [],
                refVisitor: "",
                repeat: "not_repeat",
                isAllDay: false,
                visibility: "public",
                description: "",
                calendarId: "",
                reminderOptions: {
                    duration: 10,
                    unit: "minute",
                },
            },
            customFormat: "YYYY-MM-DD",
            fileLoading: 0,
            attachments: [],
            assetIds: [],
            usersClone: [],
            isEdit: false,
            supsisCalendars: [],
            isEnabledOAuth: false,
            startDate: new Date(),
            endDate: new Date(Date.now() + 24 * 60 * 60 * 1000),
            startTime: new Date(),
            endTime: new Date(Date.now() + 60 * 60 * 1000),
            startDateString: moment().format('YYYY-MM-DD'),
            endDateString: moment().add(1, 'day').format('YYYY-MM-DD'),
            startTimeString: moment().format('HH:mm'),
            endTimeString: moment().add(1, 'hour').format('HH:mm'),
            customRepeatModal: false,
            customRecurrence: {},
            deleteModal: false,
            selectDeleteType: "single",
            visitors: [],
            remindDates: ["minute", "hour", "day", "week"],
            duration: 10,
            unit: "minute",
            isSupsisEvent: true,
        };
    },
    computed: {
        ...mapState({
            users: (state) => state.user.users.data,
            site: (state) => state.site.site,
            user: (state) => state.auth.user,
        }),
        ...mapGetters({}),
    },
    methods: {
        isMaskContactInfo,
        maskField(key, val) {
            return isMaskContactInfo(key) ? maskContactInfo(val) : val;
        },
        ...mapActions({
            isEnableUserAccount: "calendar/isEnableUserAccount",
            getCalendarSettings: "calendar/getCalendarSettings",
            getVisitorList: "visitor/getVisitorList",
        }),
        ...mapMutations({}),
        getGoogleMeetLink() {
            const conferenceId = this.eventModalData.raw?.conferenceData?.conferenceId;
            if (conferenceId) {
                return `https://meet.google.com/${conferenceId}`;
            }
            return null;
        },
        changeRepeat(val) {
            this.customRepeatModal = val === "custom";
        },
        getLinkGoogle() {
            const eventText = this.eventModalData.summary;
            let { end, start } = this.getDate();
            start = start.replace(/[-:.+]/g, "");
            end = end.replace(/[-:.+]/g, "");
            const details = [this.eventModalData.description];
            const params = `action=TEMPLATE&text=${eventText}&dates=${start}/${end}&details=${details.join(
                "\n"
            )}&sf=true&output=xml&`;
            return `https://calendar.google.com/calendar/render?${encodeURI(params)}`;
        },
        getLinkYahoo() {
            let { end, start } = this.getDate();
            start = start.replace(/[-:.+]/g, "");
            end = end.replace(/[-:.+]/g, "");
            const details = [this.eventModalData.description];
            const title = this.eventModalData.summary;
            const params = `desc=${details}&dur=false&et=${end}&in_loc=&st=${start}&title=${title}&v=60`;
            return `https://calendar.yahoo.com/?${encodeURI(params)}`;
        },
        deleteEventSelectType() {
            let payload = { eventId: this.eventModalData._id, selectDeleteType: this.selectDeleteType };
            this.$emit("delete-event", payload);
            this.deleteModal = false;
        },
        deleteEvent() {
            if (Object.keys(this.eventDetail).length > 0 && this.eventDetail.groupEventCount > 1) {
                this.deleteModal = true;
            } else {
                this.$confirm({
                    title: this.$t("calendar.deleteEvent"),
                    content: this.$t("calendar.deleteEventConfirm"),
                    okText: this.$t("calendar.delete"),
                    okType: "danger",
                    cancelText: this.$t("calendar.close"),
                    onOk: async () => {
                        this.$emit("delete-event", { eventId: this.eventModalData._id });
                    },
                });
            }
        },
        getDate() {
            // start time ve date değerlieri birlşetirilir
            const newStartTime = moment(this.startTime).format("HH:mm");
            const newEndTime = moment(this.endTime).format("HH:mm");
            const newStartDate = moment(this.startDate).format("YYYY-MM-DD");
            const newEndDate = moment(this.endDate).format("YYYY-MM-DD");
            let newStartDateFormat = "";
            let newEndDateFormat = "";
            if (!this.eventModalData.isAllDay) {
                newStartDateFormat = new Date(
                    parseInt(newStartDate.split("-")[0]),
                    parseInt(newStartDate.split("-")[1]) - 1,
                    parseInt(newStartDate.split("-")[2]),
                    parseInt(newStartTime.split(":")[0]),
                    parseInt(newStartTime.split(":")[1])
                );
                newEndDateFormat = new Date(
                    parseInt(newEndDate.split("-")[0]),
                    parseInt(newEndDate.split("-")[1]) - 1,
                    parseInt(newEndDate.split("-")[2]),
                    parseInt(newEndTime.split(":")[0]),
                    parseInt(newEndTime.split(":")[1])
                );
            } else {
                newStartDateFormat = new Date(
                    parseInt(newStartDate.split("-")[0]),
                    parseInt(newStartDate.split("-")[1]) - 1,
                    parseInt(newStartDate.split("-")[2]),
                    0,
                    0
                );
                newEndDateFormat = new Date(
                    parseInt(newEndDate.split("-")[0]),
                    parseInt(newEndDate.split("-")[1]) - 1,
                    parseInt(newEndDate.split("-")[2]),
                    0,
                    0
                );
            }
            const start = moment(newStartDateFormat).format();
            const end = moment(newEndDateFormat).format();
            return { start, end };
        },
        async editOrCreateEvent() {
            if (this.eventModalData.summary === "") {
                this.$message.error(this.$t("calendar.notEmptyTitle"));
                return false;
            }
            let { start, end } = this.getDate();
            start = moment(start).tz(this.timezone).format();
            end =
                end !== "Invalid date"
                    ? moment(end).tz(this.timezone).format()
                    : moment(start).tz(this.timezone).add(1, "hours").format();
            let data = this.eventModalData;
            const newData = {
                eventId: Object.keys(this.eventDetail).length > 0 ? this.eventDetail._id : "",
                isEdit: this.isEdit,
                userId: this.user._id,
                calendarId:
                    data.calendarId !== "" ? data.calendarId : this.calendarList.filter((x) => !!x.isDefault)[0]._id,
                summary: data.summary,
                type: "event",
                timezone: this.timezone,
                start,
                end,
                isAllDay: data.isAllDay,
                repeat: data.repeat,
                assets: this.assetIds,
                visibility: data.visibility,
                description: data.description,
                color: data.color,
                refUsers: data.refUsers,
                refVisitor: data.refVisitor,
                customRecurrence: this.customRecurrence,
                reminderOptions: data.reminderOptions,
            };
            await this.eventFunction(newData);
        },
        deleteAttachment(index) {
            this.attachments = this.attachments.filter((attachment, i) => i !== index);
        },
        async selectFile() {
            let fileEl = document.createElement("input");
            fileEl.setAttribute("type", "file");
            fileEl.setAttribute("multiple", "multiple");
            fileEl.onchange = async () => {
                let file = fileEl.files[0];
                for (let i = 0; i < fileEl.files.length; i++) {
                    if (file.size <= 20 * 1024 * 1024) {
                        let uploadFile = {
                            fileNumber: Math.random(),
                            finished: false,
                            percent: 0,
                            failed: false,
                        };
                        await this.uploadFile(fileEl.files[i], uploadFile);
                    } else {
                        log.warn("input is not suitable for send");
                        this.$toasted.error(this.$t("message.assetOversizeWithExt"), {
                            duration: 3000,
                            position: "bottom-center",
                        });
                    }
                }
            };
            fileEl.click();
        },
        async uploadFile(file, uploadFile) {
            this.fileLoading = 0;
            const newSize = (file.size / 100).toFixed(2);
            const fileId = this.attachments.length + 1;
            this.attachments.push({ file, newSize, fileId });
            console.log("uploadFile this.attachments", this.attachments);

            const fileType = getExtensionFromFileName(file.name);
            let path = `${this.site._id}/calendar/attachments/`;

            let { data } = await uploadAsset({
                path,
                mime: file.type,
                ext: mimeTypes[file.type] || fileType || "supsis",
                name: file.name,
                size: file.size,
                type: "calendar",
            });
            this.assetIds.push(data.asset.id);

            if (file.size <= 10 * 1024 * 1024) {
                await axios({
                    method: data.method,
                    url: data.url,
                    data: file,
                    headers: {
                        "Content-Type": file.type,
                    },
                    onUploadProgress: await function (progressEvent) {
                        this.fileLoading = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100));
                    }.bind(this),
                }).then((res) => {
                    console.log("created asset res", res);
                });
            } else {
                log.warn("input is not suitable for send");
                this.$toasted.error(this.$t("message.assetOversize"), {
                    duration: 3000,
                    position: "bottom-center",
                });
            }
        },
        async getVisitorsFunction(searchText = "") {
            console.log("🔍 Visitor listesi isteniyor...", { searchText });
            console.log("🌍 Site bilgisi:", this.site);
            console.log("👤 User bilgisi:", this.user);

            try {
                const requestParams = {
                    page: 1,
                    pageSize: 50
                };

                if (searchText && searchText.trim()) {
                    requestParams.query = searchText.trim();
                }


                console.log("📡 API'ye gönderilen parametreler:", requestParams);

                if (!this.getVisitorList) {
                    console.error("❌ getVisitorList action bulunamadı!");
                    this.$message.error("Visitor listesi fonksiyonu bulunamadı");
                    return;
                }

                const res = await this.getVisitorList(requestParams);
                console.log("📥 Visitor API tam yanıtı:", JSON.stringify(res, null, 2));

                if (res && res.data && res.data.visitors && Array.isArray(res.data.visitors)) {
                    this.visitors = res.data.visitors;
                    console.log("✅ Visitors başarıyla yüklendi (res.data.visitors):", this.visitors.length, "adet");
                    console.log("👥 İlk 3 visitor:", this.visitors.slice(0, 3));
                } else if (res && res.visitors && Array.isArray(res.visitors)) {
                    this.visitors = res.visitors;
                    console.log("✅ Visitors başarıyla yüklendi (res.visitors):", this.visitors.length, "adet");
                    console.log("👥 İlk 3 visitor:", this.visitors.slice(0, 3));
                } else if (res && res.data && res.data.data && Array.isArray(res.data.data)) {
                    this.visitors = res.data.data;
                    console.log("✅ Visitors başarıyla yüklendi (res.data.data):", this.visitors.length, "adet");
                    console.log("👥 İlk 3 visitor:", this.visitors.slice(0, 3));
                } else if (res && res.data && Array.isArray(res.data)) {
                    this.visitors = res.data;
                    console.log("✅ Visitors başarıyla yüklendi (res.data):", this.visitors.length, "adet");
                    console.log("👥 İlk 3 visitor:", this.visitors.slice(0, 3));
                } else if (res && Array.isArray(res)) {
                    this.visitors = res;
                    console.log("✅ Visitors başarıyla yüklendi (res):", this.visitors.length, "adet");
                    console.log("👥 İlk 3 visitor:", this.visitors.slice(0, 3));
                } else {
                    console.warn("⚠️ Visitor data yapısı beklenenden farklı:", res);
                    console.warn("⚠️ typeof res:", typeof res);
                    console.warn("⚠️ res.keys:", res ? Object.keys(res) : 'null');
                    this.visitors = [];
                }

                if (this.visitors.length === 0) {
                    console.warn("⚠️ Visitor listesi boş döndü - veritabanında visitor var mı?");
                    this.$message.info("Henüz kayıtlı visitor bulunamadı");
                }

            } catch (error) {
                console.error("❌ Visitor listesi yüklenirken hata:", error);
                console.error("❌ Error stack:", error.stack);
                this.visitors = [];
                this.$message.error(`Visitor listesi yüklenemedi: ${error.message}`);
            }
        },
        copyMeetLink() {
            const meetLink = this.getGoogleMeetLink();
            if (meetLink) {
                navigator.clipboard.writeText(meetLink);
                this.$message.success(this.$t('auto.meetingLinkCopiedSuccess'));
            }
        },
        onStartDateStringChange() {
            this.startDate = new Date(this.startDateString + 'T00:00:00');
            console.log('Başlangıç tarihi değişti:', this.startDateString, this.startDate);
        },
        onEndDateStringChange() {
            this.endDate = new Date(this.endDateString + 'T00:00:00');
            console.log('Bitiş tarihi değişti:', this.endDateString, this.endDate);
        },
        onStartTimeStringChange() {
            const dateStr = this.startDateString || moment().format('YYYY-MM-DD');
            this.startTime = new Date(dateStr + 'T' + this.startTimeString + ':00');
            console.log('Başlangıç saati değişti:', this.startTimeString, this.startTime);
        },
        onEndTimeStringChange() {
            const dateStr = this.endDateString || moment().format('YYYY-MM-DD');
            this.endTime = new Date(dateStr + 'T' + this.endTimeString + ':00');
            console.log('Bitiş saati değişti:', this.endTimeString, this.endTime);
        },
    },
    async mounted() {
        console.log("EventTag component mounted, visitor listesi yükleniyor...");
        await this.getVisitorsFunction();
        this.isEnableUserAccount({ userId: this.user._id }).then((res) => {
            this.isEnabledOAuth = !!res;
        });
        if (Object.keys(this.eventDetail).length > 0) {
            console.log("event detail--", this.eventDetail);
            this.isSupsisEvent = this.eventDetail.integrationType === "supsis";

            this.startTime = moment(this.eventDetail.start).toDate();
            this.endTime = moment(this.eventDetail.end).toDate();
            this.startDate = moment(this.eventDetail.start).toDate();
            this.endDate = moment(this.eventDetail.end).toDate();

            this.startDateString = moment(this.eventDetail.start).format('YYYY-MM-DD');
            this.endDateString = moment(this.eventDetail.end).format('YYYY-MM-DD');
            this.startTimeString = moment(this.eventDetail.start).format('HH:mm');
            this.endTimeString = moment(this.eventDetail.end).format('HH:mm');

            this.duration = this.eventDetail.reminderOptions?.duration || 10;
            this.unit = this.eventDetail.reminderOptions?.unit || "minute";
            this.eventModalData = _.cloneDeep(this.eventDetail);
            this.eventModalData.isAllday = this.eventDetail.isAllDay;
            if (!this.eventModalData.reminderOptions) {
                this.eventModalData.reminderOptions = {
                    duration: 10,
                    unit: "minute"
                };
            }
            this.timezone = this.eventDetail.timezone || "Europe/Istanbul";
            this.isEdit = true;
        } else {
            this.getCalendarSettings({ userId: this.user._id }).then((res) => {
                this.timezone = res?.timezone || "Europe/Istanbul";
            });
            this.eventModalData = _.cloneDeep(this.modalBaseData);

            this.startDate = moment(this.selectedStartDate).toDate();
            this.startTime = moment(this.selectedStartDate).toDate();
            this.endTime = moment(this.selectedStartDate).add(1, "hours").toDate();

            this.startDateString = moment(this.selectedStartDate).format('YYYY-MM-DD');
            this.startTimeString = moment(this.selectedStartDate).format('HH:mm');

            if (this.selectedEndDate) {
                this.endDate = moment(this.selectedEndDate).toDate();
                this.endTime = moment(this.selectedEndDate).toDate();
                this.endDateString = moment(this.selectedEndDate).format('YYYY-MM-DD');
                this.endTimeString = moment(this.selectedEndDate).format('HH:mm');
            } else {
                this.endTime = moment(this.selectedStartDate).add(1, "hours").toDate();
                this.endTimeString = moment(this.selectedStartDate).add(1, "hours").format('HH:mm');
                this.endDate = moment(this.selectedStartDate).add(1, "day").toDate();
                this.endDateString = moment(this.selectedStartDate).add(1, "day").format('YYYY-MM-DD');
            }
            // supsis takvimleri googlea entegre olmuş olabilir. buna göre raw id alınır
            const defaultCalendar = this.calendarList.filter((x) => !!x.isDefault && x.userId._id === this.user._id)[0];
            this.eventModalData.calendarId = this.calendarList.length > 0 && defaultCalendar ? defaultCalendar._id : "";
            this.isEdit = false;
        }
        this.usersClone = this.users;
        this.supsisCalendars =
            this.calendarList.length > 0
                ? this.calendarList
                      .filter((x) => x.type === "supsis")
                      .map((x) => {
                          return { value: x._id, label: x.summary };
                      })
                : [];
        this.eventModalData.summary = this.eventSummary !== "" ? this.eventSummary : this.eventModalData.summary;
        this.eventModalData.refVisitor = this.refVisitor !== "" ? this.refVisitor : this.eventModalData.refVisitor;
    },
    watch: {
        duration(val) {
            if (!this.eventModalData.reminderOptions) {
                this.eventModalData.reminderOptions = {};
            }
            this.eventModalData.reminderOptions.duration = val;
        },
        unit(val) {
            if (!this.eventModalData.reminderOptions) {
                this.eventModalData.reminderOptions = {};
            }
            this.eventModalData.reminderOptions.unit = val;
        },
        customRecurrence(val) {
            this.customRepeatModal = false;
        },
        calendarList(val) {
            console.log("eventTag watch calendarList", { calendarList: val });
            const defaultCalendar = this.calendarList.filter(
                (x) => !!x.isDefault && x.userId._id === this.user._id
            )[0];
            this.eventModalData.calendarId = defaultCalendar ? defaultCalendar._id : "";
            this.supsisCalendars = val
                .filter((x) => x.type === "supsis")
                .map((x) => {
                    return { value: x._id, label: x.summary };
                });
        },
        selectedStartDate(val) {
            console.log("selectedStartDate watch", val);
            if (Object.keys(this.eventDetail).length === 0) {
                this.startDate = moment(val).toDate();
                this.startTime = moment(val).toDate();
                this.startDateString = moment(val).format('YYYY-MM-DD');
                this.startTimeString = moment(val).format('HH:mm');
                
                // End date'i sadece selectedEndDate yoksa güncelle
                if (!this.selectedEndDate) {
                    this.endTime = moment(val).add(1, "hours").toDate();
                    this.endTimeString = moment(val).add(1, "hours").format('HH:mm');
                    this.endDate = moment(val).add(1, "day").toDate();
                    this.endDateString = moment(val).add(1, "day").format('YYYY-MM-DD');
                }
            }
        },
        selectedEndDate(val) {
            console.log("selectedEndDate watch", val);
            if (val && Object.keys(this.eventDetail).length === 0) {
                this.endDate = moment(val).toDate();
                this.endTime = moment(val).toDate();
                this.endDateString = moment(val).format('YYYY-MM-DD');
                this.endTimeString = moment(val).format('HH:mm');
            }
        },
        eventDetail(val) {
            console.log("this.eventDetail watch", val);
            if (Object.keys(val).length > 0) {
                this.startTime = moment(this.eventDetail.start).toDate();
                this.endTime = moment(this.eventDetail.end).toDate();
                this.startDate = moment(this.eventDetail.start).toDate();
                this.endDate = moment(this.eventDetail.end).toDate();

                this.startDateString = moment(this.eventDetail.start).format('YYYY-MM-DD');
                this.endDateString = moment(this.eventDetail.end).format('YYYY-MM-DD');
                this.startTimeString = moment(this.eventDetail.start).format('HH:mm');
                this.endTimeString = moment(this.eventDetail.end).format('HH:mm');

                this.eventModalData = val;
                this.isEdit = true;
            } else {
                this.isEdit = false;
            }
        },
        'eventModalData.isAllDay'(newVal) {
            console.log("isAllDay değişti:", newVal);
            if (newVal) {
                this.endDate = moment(this.startDate).add(1, 'day').toDate();
                this.endDateString = moment(this.startDate).add(1, 'day').format('YYYY-MM-DD');
            } else {
                this.endTime = moment(this.startTime).add(1, 'hour').toDate();
                this.endTimeString = moment(this.startTime).add(1, 'hour').format('HH:mm');
            }
        },
    },
};
</script>

<style lang="scss">
.ant-select-selection {
    background-color: white !important;
}
</style>

<style lang="scss" scoped>
.delete-title {
    width: fit-content;
    font-weight: 700;
    font-size: 19px;
    margin-bottom: 10px;
}

.duration {
    border: 0.5px solid grey;
    padding: 5px;
    border-radius: 10px;
}

.footer-btns {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
}

.footer-btn {
    padding: 6px 10px;
    font-size: 13px;
    border-radius: 5px;
    margin-right: 10px;
    cursor: pointer;
    background-color: #107fc3;
    color: white;
}

.fc-view-harness.fc-view-harness-active {
    max-height: 500px;
}

#event-modal {
    background-color: #ffffff;
    height: 100%;

    .footer-action {
        display: flex;
        justify-content: end;
        border-top: 0.5px solid black;
        margin-top: 20px;

        .btn {
            background-color: rgb(66, 133, 244);
            color: white;
            padding: 5px;
            margin: 5px;
            border-radius: 10px;

            &.delete {
                background-color: #ff4d4f;
            }
        }
    }

    .info {
        margin-top: 15px;
        display: flex;
        align-items: center;
    }

    .event-input {
        margin-top: 15px;
        width: 100%;
        border: none;
        border-bottom: 0.5px solid grey;
        margin-bottom: 10px;

        &:hover {
            border-bottom: 1px solid #021eb6;
        }
    }

    .single {
        margin-right: 5px;
    }

    .ant-calendar-picker,
    .ant-time-picker {
        width: 100%;
    }

    .ant-calendar-picker-input,
    .ant-time-picker-input {
        cursor: pointer;
    }

    .custom-datetime-container {
        display: flex;
        flex-direction: column;
        gap: 10px;
        margin-left: 10px;
        width: 100%;
    }

    .datetime-row {
        display: flex;
        align-items: center;
        gap: 10px;
    }

    .datetime-label {
        min-width: 70px;
        font-size: 14px;
        color: #555;
        font-weight: 500;
    }

    .custom-date-input,
    .custom-time-input {
        border: 1px solid #d9d9d9;
        border-radius: 6px;
        padding: 4px 11px;
        font-size: 14px;
        transition: border-color 0.3s;
        background-color: #fff;

        &:hover {
            border-color: #40a9ff;
        }

        &:focus {
            border-color: #40a9ff;
            outline: 0;
            box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
        }
    }

    .custom-date-input {
        min-width: 150px;
    }

    .custom-time-input {
        min-width: 120px;
    }

    .description {
        margin-left: 10px;
    }

    .attach-icon {
        font-size: 20px;
    }

    .attachments {
        .attachment {
            margin-bottom: 5px;
            background-color: aliceblue;
            padding: 3px;
            border-radius: 5px;
            display: flex;
            align-items: center;
        }
    }

    .lock-icon {
        font-size: 20px;
        margin-right: 10px;
    }

    .attache_file_btn {
        border: none;
        padding: 5px;
        border-radius: 5px;
        background-color: white;

        &:hover {
            background-color: #e8e8e8 !important;
        }
    }

    .google-meet-btn {
        margin-top: 10px;
        margin-bottom: 10px;
    }

    .meet-link-container {
        display: flex;
        align-items: center;
        margin-top: 5px;

        .meet-link {
            font-size: 12px;
            color: #555;
            background-color: #f5f5f5;
            padding: 4px 8px;
            border-radius: 4px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            max-width: 300px;
        }
    }
}
</style>
